import React from "react";
import "./chart-tooltip.scss";

type CustomChartTooltipProps = {
  active?: boolean;
  payload?: any[];
  label?: string;
  title?: string;
  formatTooltip?: (value: number, key: string) => string;
  formatLabel?: (label: string) => string;
  formatName?: (name: string) => string;
  hideSeriesName?: boolean;
};

const CustomChartTooltip: React.FC<CustomChartTooltipProps> = ({
  active,
  payload,
  label,
  formatTooltip,
  formatLabel,
  formatName,
  hideSeriesName,
}) => {
  if (!active || !payload || payload.length === 0) {return null;}

  return (
    <div className="chart-tooltip-container">
      <div className="chart-tooltip-label">{formatLabel ? formatLabel(label ?? "") : label}</div>

      {payload?.map((item, index) => {
        const value = item?.value ?? 0;
        const key = item?.dataKey ?? "";
        const formatted = formatTooltip
          ? formatTooltip(value, key)
          : `${value}`;
        const name = formatName ? formatName(item.name) : item.name;

        return (
          <div key={index} className="chart-tooltip-value">
            {hideSeriesName ? null : <span className="chart-tooltip-title">{name}:</span>}
            <span className="chart-tooltip-number">{formatted}</span>
          </div>
        );
      })}
    </div>
  );
};

export default CustomChartTooltip;